module.exports = __webpack_public_path__ + "static/media/image-vedio.65554259.png";